import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldBody, FieldHeader } from 'web-ui-components/lib/molecules/forms';
import { GenericTextArea as TextArea } from 'web-ui-components/lib/data/capture';

export class GenericTextArea extends Component {
	componentDidUpdate() {
		const { isFocusOn, id } = this.props;
		if (isFocusOn && this[id]) {
			this[id].focus();
		}
	}
	render() {
		const {
			id,
			label,
			value,
			onChange,
			errorMessage,
			description,
			isValid,
			showValidation,
			onFocus,
			onBlur,
			maximumCharacters,
		} = this.props;
		return (
			<Field>
				<FieldHeader
					name="otherPaymentReference"
					titleText={label}
					description={description}
					hasError={!isValid && showValidation}
					validationMessage={errorMessage}
				/>
				<FieldBody>
					<TextArea
						id={id}
						value={value}
						maximumCharacters={maximumCharacters}
						onChange={onChange}
						onFocus={onFocus}
						onBlur={onBlur}
						ref={(node) => {
							this[id] = node;
						}}
					/>
				</FieldBody>
			</Field>
		);
	}
}

GenericTextArea.propTypes = {
	id: PropTypes.string.isRequired,
	label: PropTypes.string,
	value: PropTypes.string,
	onChange: PropTypes.func,
	errorMessage: PropTypes.string,
	description: PropTypes.string,
	isValid: PropTypes.bool,
	showValidation: PropTypes.bool,
	isFocusOn: PropTypes.bool,
	onFocus: PropTypes.func,
	onBlur: PropTypes.func,
	maximumCharacters: PropTypes.number,
};

export default GenericTextArea;
